/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  SeekButton,
  Text,
} from './SeekStyles';
import { usePlayer } from '../../../PlayerContext';
import { useOptions } from '../../../OptionsContext';
import { selectNormalizedCurrentTime } from '../../../selectors';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

function Rewind({ isMini }) {
  const player = usePlayer();
  const { seekStepInSeconds } = useOptions();

  const rights = useSelector(state => state.playback.rights);
  const isPlayingDaiAds = useSelector(state => state.playback.isPlayingDaiAds);

  const disabled = (isPlayingDaiAds && !rights.adsRewind) || (!isPlayingDaiAds && !rights.rewind) || false;
  const maxRewindBySeconds = useSelector(selectNormalizedCurrentTime);

  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);

  const rewind = () => {
    if (!disabled) {
      player.rewind(Math.min(maxRewindBySeconds, seekStepInSeconds));
    }
  };

  return (
    <SeekButton
      enabled={!disabled}
      isMini={isMini}
      isMobile={isMobile}
      viewBox="0 0 29 32"
      onClick={rewind}
      data-cy="hp-seek-backward-button"
    >
      <g fill="none">
        <path d="M0-1h28v28H0z" />
        <Text x="8" y="22">
          {seekStepInSeconds}
        </Text>
        <path d="M14.5007 31.9167C10.8264 31.9167 7.67237 30.6962 5.03869 28.2552C2.40501 25.8143 0.946852 22.7952 0.664213 19.1979C0.638519 18.8896 0.734873 18.6198 0.953276 18.3886C1.17168 18.1573 1.44789 18.0417 1.78192 18.0417C2.09025 18.0417 2.35362 18.1509 2.57203 18.3693C2.79043 18.5877 2.92532 18.8639 2.97671 19.1979C3.25935 22.1528 4.49269 24.6259 6.67671 26.6172C8.86074 28.6085 11.4687 29.6042 14.5007 29.6042C17.7125 29.6042 20.4425 28.48 22.6908 26.2318C24.939 23.9835 26.0632 21.2535 26.0632 18.0417C26.0632 14.8299 24.9712 12.0998 22.7871 9.85158C20.6031 7.60331 17.9052 6.47918 14.6934 6.47918H13.8455L15.8496 8.48335C16.0809 8.7146 16.1965 8.98439 16.1965 9.29272C16.1965 9.60106 16.0809 9.87085 15.8496 10.1021C15.6184 10.3333 15.3486 10.449 15.0403 10.449C14.7319 10.449 14.4621 10.3333 14.2309 10.1021L10.184 6.05522C10.0555 5.92675 9.9656 5.79828 9.91421 5.66981C9.86282 5.54134 9.83713 5.40002 9.83713 5.24585C9.83713 5.09168 9.86282 4.95036 9.91421 4.82189C9.9656 4.69342 10.0555 4.56495 10.184 4.43647L14.2694 0.351058C14.475 0.145502 14.7319 0.0427246 15.0403 0.0427246C15.3486 0.0427246 15.6184 0.145502 15.8496 0.351058C16.0552 0.582308 16.158 0.852099 16.158 1.16043C16.158 1.46877 16.0552 1.72571 15.8496 1.93127L13.6142 4.16668H14.5007C16.4278 4.16668 18.2328 4.5264 19.9158 5.24585C21.5988 5.96529 23.0698 6.95453 24.3288 8.21356C25.5878 9.47259 26.5771 10.9436 27.2965 12.6266C28.0159 14.3096 28.3757 16.1146 28.3757 18.0417C28.3757 19.9688 28.0159 21.7738 27.2965 23.4568C26.5771 25.1398 25.5878 26.6108 24.3288 27.8698C23.0698 29.1288 21.5988 30.1181 19.9158 30.8375C18.2328 31.557 16.4278 31.9167 14.5007 31.9167Z" fill="white" />
      </g>
    </SeekButton>
  );
}

Rewind.propTypes = {
  isMini: PropTypes.bool,
};

export default React.memo(Rewind);
